'use client';

import { Fragment } from 'react';
import styles from './TeamCarouselSection.module.scss';
import { useAOS } from '@/src/lib/hooks/useAOS';
import { TeamCarousel, TeamMemberData } from '../TeamCarousel/TeamCarousel';

export interface TeamCarouselSectionProps {
  eyebrow?: string;
  title?: string;
  caption?: string;
  members?: TeamMemberData[];
  backgroundImage?: string;
  step?: number;
}

const renderTitle = (title: string) => {
  const parts = title.split('*');
  return parts.map((part, i) => {
    if (i % 2 === 1) {
      return <em key={i}>{part}</em>;
    }
    const segments = part.split('—');
    return segments.map((segment, j) => (
      <Fragment key={j}>
        {segment}
        {j < segments.length - 1 && <span className={styles.titleDash}>—</span>}
      </Fragment>
    ));
  });
};

export const TeamCarouselSection = ({
  eyebrow = 'Une équipe à votre disposition',
  title = 'Un *unique* interlocuteur — qui orchestre les ressources et assure une livraison *sans surprise*.',
  caption = 'Une équipe pluridisciplinaire dédiée, coordonnée par un seul responsable.',
  members,
  backgroundImage,
  step,
}: TeamCarouselSectionProps) => {
  useAOS();

  return (
    <div className={styles.root}>
      {eyebrow && (
        <div className={styles.eyebrowRow}>
          {step && (
            <span
              className={styles.stepBadge}
              data-aos="fade-down"
              data-aos-duration="600"
              data-aos-once="true"
            >
              {step}
            </span>
          )}
          <p className={styles.eyebrow}>{eyebrow}</p>
        </div>
      )}
      <h2 className={styles.title}>{renderTitle(title)}</h2>
      <TeamCarousel members={members} backgroundImage={backgroundImage} caption={caption} />
    </div>
  );
};
